import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from '@shoelace-style/shoelace/dist/react';


function VideoExpandable({
  company,
  companyName,
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited
}) {
  const navigate = useNavigate();

  const { preview, setPreview } = useContext(CreativeContext);
  const [progress, setProgress] = useState(0);
  const [inputFields, setInputFields] = useState([
    {
      img_id: "0",
      image: "",
    },
    {
      img_id: "1",
      image: "",
    },
  ]);

  const imageChange = async (e, index) => {
    if (e.target.files && e.target.files.length > 0) {
      imageUrl(e.target.files[0], index);
    } else {
      if (flag === "edit") {
        if (editdata.gallery[index]) {
          const values = [...inputFields];
          values[index].image = editdata.gallery[index].image;
          setInputFields(values);
          const { gallery } = preview;
          gallery[index] = editdata.gallery[index]?.image;
          setPreview({ ...preview, gallery: gallery });
        } else {
          setProgress(0);
          setValue(`image${index}`, "");
          const values = [...inputFields];
          values[index].image = "";
          setInputFields(values);
          const { gallery } = preview;
          gallery[index] = "";
          setPreview({ ...preview, gallery: gallery });
        }
      } else {
        setProgress(0);
        setValue(`image${index}`, "");
        const values = [...inputFields];
        values[index].image = "";
        setInputFields(values);
        const { gallery } = preview;
        gallery[index] = "";
        setPreview({ ...preview, gallery: gallery });
      }
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  
  const imageUrl = async (imgFile, index) => {
    const formData = new FormData();
    formData.append('files', imgFile)
    try {
      let url = await api({
        url: `/upload/brandImageExpandable`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
          setProgress(Math.round((100 * data.loaded) / data.total))
        },
      });
      if (url.code === 200) {
        let values = [...inputFields];
        values[index].image = url.data.data;
        setInputFields(values);
        const { gallery } = preview;
        gallery[index].image = url.data.data;
        values[index].img_id = `${index}`;
        setPreview({ ...preview, gallery: gallery });
      } else {
        setProgress(0)
        setValue(`image${index}`, "");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };
  
  

  useEffect(() => {
    if (flag === "edit") {
      setPreview({
        ...preview,
        sub_type: editdata.sub_type,
        gallery: editdata.gallery,
        start_time:editdata.impressions,
        end_time:editdata.clicks
      });
      setInputFields(editdata.gallery || inputFields)
    }
    else{
      setPreview({
        ...preview, gallery : inputFields
      })
    }
   
  }, [company]);



  const onSubmit = async (data) => {
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        company_name: companyName,
        // adv_id: advId,
        creative_name,
        creative_type,
        sub_type: subtype,
        inputFields,
        start_time:data.start_time,
        end_time:data.end_time,
        clickurl: data.clickurl,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/brandad/video-expandable`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_id: editdata.creative_id,
        creative_name: creative_name,
        start_time:data.start_time,
        end_time:data.end_time,
        clickurl: data.clickurl,
        inputFields,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
      };
      try {
        let res = await api({
          url: `/creatives/brandad/edit-video-expandable`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);

        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="row">
            <section className="col-12">
              <div className="mb-3">
                <label className="form-label">Thumbnail Image 1</label><br />
                <span>(Image height should be greater than width )</span>
                <input
                  className="form-control mb-2"
                  type="file"
                  id="formFile"
                  name="files"
                  {...register("image", {
                    required: inputFields[0]?.image ? false : true,
                    onChange: (e) => imageChange(e, 0),
                  })}
                />
                {errors.image && (
                  <p className="text-red-600">Image is mandatory</p>
                )}
                {
                  progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar> : inputFields[0].image !== "" ? (
                    <div className="d-flex align-items-center gap-2">
                      <span className="text-success">✓</span>
                      <span>{`${inputFields[0].image}`}</span>
                    </div>
                  ) : (
                    flag === "edit" && <span>{`${inputFields[0].image}`}</span>
                  )}
              </div>
              <div className="mb-3">
                <label className="form-label">Expandable Image 2</label><br />
                <span>(Image height should be greater than width )</span>
                <input
                  className="form-control mb-2"
                  type="file"
                  id="formFile"
                  name="files"
                  {...register("image1", {
                    required: inputFields[1].image ? false : true,
                    onChange: (e) => imageChange(e, 1),
                  })}
                />
                {errors.image && (
                  <p className="text-red-600">Image is mandatory</p>
                )}
                {
                  progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar> : inputFields[1].image !== "" ? (
                    <div className="d-flex align-items-center gap-2">
                      <span className="text-success">✓</span>
                      <span>{`${inputFields[1].image}`}</span>
                    </div>
                  ) : (
                    flag === "edit" && <span>{`${inputFields[1].image}`}</span>
                  )}
              </div>
              <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Start time</label>
                      <input className="form-control" type="number" defaultValue={editdata.impressions} placeholder="Enter Start time in seconds" {...register('start_time', {required:true, min:1,onChange : (e) => setPreview({...preview, start_time:e.target.value})})}/>
                    </div>
                    <div className="col">
                    <label className="form-label">End time</label>
                      <input className="form-control" type="number" defaultValue={editdata.clicks} placeholder="Enter End time in seconds" {...register('end_time', {required:true, min:1, onChange : (e) => setPreview({...preview, end_time:e.target.value})})}/>
                    </div>
              </div>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Click URL / Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editdata.click_url}
                    name="clickurl"
                    {...register("clickurl", {
                      required: false,
                      pattern: {
                        value:
                        /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|^(0\d{10}|[6-9]\d{9})$/,
                        message: "Enter a Valid URL or Mobile Number",
                      },
                    })}
                  />
                  {errors.clickurl && (
                    <p className="text-red-600">{errors.clickurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">Impression URL - Primary</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.primary
                        : null
                    }
                    {...register("impurl", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl && (
                    <p className="text-red-600">{errors.impurl.message}</p>
                  )}
                </div>
                <div className="col">
                  <label className="form-label">
                    Impression URL - Secondary
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={
                      editdata.impression_tracking_url
                        ? editdata.impression_tracking_url.secondary
                        : null
                    }
                    {...register("impurl1", {
                      required: false,
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                        message: "Enter a Valid URL",
                      },
                    })}
                  />
                  {errors.impurl1 && (
                    <p className="text-red-600">{errors.impurl1.message}</p>
                  )}
                </div>
              </div>
              <div className="my-3 text-end">
                <button type="submit" className="btn btn-primary" disabled={(progress > 0 && progress < 100) ? true : false}>
                  Save Creative
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </>
  );
}

export default VideoExpandable;